var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownM(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1014 14.3893L5.0598 7.34768C4.82029 7.10817 4.53687 6.9924 4.20953 7.00039C3.8822 7.00837 3.59878 7.13212 3.35927 7.37163C3.11976 7.61114 3 7.89456 3 8.2219C3 8.54923 3.11976 8.83265 3.35927 9.07216L10.7362 16.4252C10.9278 16.6168 11.1434 16.7605 11.3829 16.8563C11.6224 16.9521 11.8619 17 12.1014 17C12.341 17 12.5805 16.9521 12.82 16.8563C13.0595 16.7605 13.2751 16.6168 13.4667 16.4252L20.8436 9.04821C21.0831 8.8087 21.1989 8.52927 21.1909 8.20992C21.1829 7.89057 21.0592 7.61114 20.8197 7.37163C20.5802 7.13212 20.2967 7.01236 19.9694 7.01236C19.6421 7.01236 19.3586 7.13212 19.1191 7.37163L12.1014 14.3893Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownM);
export default __webpack_public_path__ + "static/media/arrow-down-m.010323e912f85d600000c76c8f8bf759.svg";
export { ForwardRef as ReactComponent };